















































































import {
  computed, defineComponent, reactive, ref,
} from '@vue/composition-api';
import { useFormat } from '@ideavivat/vivat-2';
import useAuth from '@/use/useAuth';

import { getPurchaseRequest, approvePurchaseRequest } from '@/api';
import { PurchaseRequest } from '@/types/purchase-request';
import useDownloadReport from '@/use/useDownloadReport';
import usePurchaseRequest from '@/use/usePurchaseRequest';
import itemTableOption from '@/table/PurchaseRequest/purchase-request-modal-items';
import receivableTableOption from '@/table/PurchaseRequest/receivable-purchase-request-modal';
import miscTableOption from '@/table/PurchaseRequest/purchase-request-modal-misc';

const NOW = useFormat.date().computerShortDate();
const defaultPurchaseRequest = {
  id: -1,
  bomId: -1,
  category: '',
  code: '',
  itemsType: '',
  status: 'PENDING',
  dueDate: NOW,
  createdAt: NOW,
  updatedAt: NOW,
  deletedAt: NOW,
  userId: -1,
  user: { id: -1 },
  items: [],
  miscItems: [],
  approved: false,
  supplier_remarks: '',
  vat: 0,
  vatType: 'NONE',
  receiveDate: NOW,
  sendDate: NOW,
};
const CommonModalWithPurchaseRequestInfo = defineComponent({
  setup(props, { root, emit }) {
    const toDate = (date: string): string => useFormat.date(date).displayShortThaiDate();
    const { classMap, translate, typeTranslate } = usePurchaseRequest();
    const modal = ref(null);
    const purchaseRequest: PurchaseRequest = reactive(defaultPurchaseRequest);
    const { getReport } = useDownloadReport();

    const { hasPermission: checkPermissionHandler } = useAuth();
    function hasPermission(name: string) {
      return checkPermissionHandler(root.$store.getters.me, name);
    }
    async function approvePurchaseRequestAction(ctx: any) {
      await approvePurchaseRequest(ctx.id);
      await prepare(ctx.id);
      emit('done');
    }

    async function prepare(id: number) {
      const result = (await getPurchaseRequest(id)).data;
      purchaseRequest.id = result.id;
      purchaseRequest.bomId = result.bom_id;
      purchaseRequest.category = result.category;
      purchaseRequest.code = result.code;
      purchaseRequest.itemsType = result.itemsType;
      purchaseRequest.status = result.status;
      purchaseRequest.dueDate = result.dueDate;
      purchaseRequest.createdAt = result.created_at;
      purchaseRequest.updatedAt = result.updated_at;
      purchaseRequest.deletedAt = result.deleted_at;
      purchaseRequest.userId = result.user_id;
      purchaseRequest.user = result.user;
      purchaseRequest.items = result.items || [];
      purchaseRequest.miscItems = result.misc_items || [];
      purchaseRequest.remarks = result.remarks || '';
      purchaseRequest.supplier_remarks = result.supplier_remarks || '';
      purchaseRequest.approved = result.approved;
      purchaseRequest.subType = result.subType;
      purchaseRequest.vat = result.vat;
      purchaseRequest.vatType = result.vatType;
      purchaseRequest.receiveDate = result.receive_date || '';
      purchaseRequest.sendDate = result.send_date || '';
    }

    async function open(id: number) {
      await prepare(id);
      (modal.value as any).open();
    }

    function close() {
      purchaseRequest.id = defaultPurchaseRequest.id;
      purchaseRequest.bomId = defaultPurchaseRequest.bomId;
      purchaseRequest.category = defaultPurchaseRequest.category;
      purchaseRequest.code = defaultPurchaseRequest.code;
      purchaseRequest.itemsType = defaultPurchaseRequest.itemsType;
      purchaseRequest.status = defaultPurchaseRequest.status;
      purchaseRequest.dueDate = defaultPurchaseRequest.dueDate;
      purchaseRequest.createdAt = defaultPurchaseRequest.createdAt;
      purchaseRequest.updatedAt = defaultPurchaseRequest.updatedAt;
      purchaseRequest.deletedAt = defaultPurchaseRequest.deletedAt;
      purchaseRequest.userId = defaultPurchaseRequest.userId;
      purchaseRequest.user = defaultPurchaseRequest.user;
      purchaseRequest.items = defaultPurchaseRequest.items;
      purchaseRequest.supplier_remarks = defaultPurchaseRequest.supplier_remarks;
      purchaseRequest.miscItems = defaultPurchaseRequest.miscItems;
      purchaseRequest.approved = defaultPurchaseRequest.approved;
      purchaseRequest.receiveDate = defaultPurchaseRequest.receiveDate || '';
      purchaseRequest.sendDate = defaultPurchaseRequest.sendDate || '';
      (modal.value as any).close();
    }

    const computedTableInformation = computed(() => {
      if (purchaseRequest.subType === 'SURFACE_TREATMENT' || purchaseRequest.subType === 'HEAT_TREATMENT' || purchaseRequest.subType === 'HEAT_TREATMENT') {
        return { data: purchaseRequest.items, option: receivableTableOption };
      }
      if (purchaseRequest.itemsType === 'MATERIALS') return { data: purchaseRequest.items, option: itemTableOption };
      return { data: purchaseRequest.miscItems, option: miscTableOption };
    });

    // use this to manually paginate pr item;
    const page = ref(1);
    const PERPAGE = 8;
    const purchaseRequestItemPaginator = computed(() => ({
      perPage: PERPAGE,
      total: computedTableInformation.value.data?.length,
      from: (page.value - 1) * PERPAGE,
      to: (page.value * PERPAGE),
      currentPage: 1,
      lastPage: computedTableInformation.value.data?.length === 0 ? 1 : Math.ceil((computedTableInformation.value.data as any).length / PERPAGE),
      totalPages: computedTableInformation.value.data?.length === 0 ? 1 : Math.ceil((computedTableInformation.value.data as any).length / PERPAGE),
    }));
    const displayData = computed(() => {
      if ((computedTableInformation.value.data as any).length < purchaseRequestItemPaginator.value.to) return (computedTableInformation.value.data as any).slice(purchaseRequestItemPaginator.value.from, (computedTableInformation.value.data as any).length);
      return (computedTableInformation.value.data as any).slice(purchaseRequestItemPaginator.value.from, purchaseRequestItemPaginator.value.to);
    });

    return {
      toDate,
      getReport,
      open,
      close,
      modal,
      classMap,
      translate,
      typeTranslate,
      hasPermission,
      purchaseRequest,
      computedTableInformation,
      page,
      PERPAGE,
      pagination: purchaseRequestItemPaginator,
      displayData,

      approvePurchaseRequestAction,
    };
  },
});

export default CommonModalWithPurchaseRequestInfo;
